import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'

// 导入相关依赖
import axios from 'axios'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

// 导入自定义指令
import tableDragScroll from './utility/tableDragScroll'

// 注册全局指令
Vue.directive('drag-scroll', tableDragScroll)

// 设置全局语言配置
dayjs.locale('zh-cn')

// 设置过滤器
Vue.filter('dateFormat', (val) => {
  if (!val) return ''
  return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
})

Vue.filter('date', (val) => {
  if (!val) return ''
  return dayjs(val).format('YYYY-MM-DD')
})

Vue.filter('time', (val) => {
  if (!val) return ''
  return dayjs(val).format('HH:mm:ss')
})

Vue.prototype.$getDateTime = (val) => {
  if (!val) return ''
  return dayjs(val).format('YYYY-MM-DD HH:mm:ss')
}

Vue.prototype.$getDate = (val) => {
  if (!val) return ''
  return dayjs(val).format('YYYY-MM-DD')
}

Vue.prototype.$getTime = (val) => {
  if (!val) return ''
  return dayjs(val).format('HH:mm:ss')
}

Vue.prototype.$http = axios

// API 地址配置：开发环境使用 localhost，生产环境通过 .env.production 配置
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:9210/server-api/'

// 请求时发送token
axios.interceptors.request.use((config) => {
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})

// 如果token过期/无效，清除本地token后跳转到登录页面（不清除会与Login页「有token直达」逻辑互踢成死循环）
axios.interceptors.response.use((res) => {
  if (res.data.meta && res.data.meta.status === 401) {
    window.sessionStorage.removeItem('token')
    router.push('/login').catch(() => {})
    return res
  } else {
    return res
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
